import VolumeUpIcon from '@mui/icons-material/VolumeUp'
import VolumeDownIcon from '@mui/icons-material/VolumeDown'
import VolumeOffIcon from '@mui/icons-material/VolumeOff'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Slider from '@mui/material/Slider'

const renderVolumeIcon = volume => {
  if (volume === 0) {
    return <VolumeOffIcon />
  }

  return volume > 0.5 ? <VolumeUpIcon /> : <VolumeDownIcon />
}

const VolumeControl = ({ muted, volume, setMuted, setVolume, showVolume, setShowVolume }) => (
  <Box
    sx={{ display: 'flex', alignItems: 'center', width: showVolume ? 100 : 'auto' }}
    onMouseEnter={() => {
      setShowVolume(true)
    }}
    onMouseLeave={() => {
      setShowVolume(false)
    }}
  >
    <IconButton
      color="inherit"
      sx={{ padding: 0 }}
      onClick={() => {
        setMuted(!muted)
      }}
    >
      {muted ? <VolumeOffIcon /> : renderVolumeIcon(volume)}
    </IconButton>
    {showVolume && (
      <Slider
        valueLabelDisplay="auto"
        valueLabelFormat={value => parseInt(value, 10)}
        size="small"
        sx={{ ml: 2 }}
        value={volume * 100}
        onChange={(_, value) => {
          setVolume(value / 100)
        }}
      />
    )}
  </Box>
)

export default VolumeControl
